import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Content } from '../components/Layout.js'
import Button from '../components/Button'
import mandrill from 'mandrill-api/mandrill'
import NotFound from './NotFound'

const mandrillClient = new mandrill.Mandrill('DJFfrMEytLKrY9eQzCc-tA')

/* eslint-disable */

class JobSpecification extends Component {
  componentWillMount () {
    setTimeout(() => this.props.setModal(true), 800)
  }

  handleForm (e, job) {
    const inputs = Array.from(document.querySelectorAll('input'))
    const formValid = inputs.every(input => input.value !== '') // including CV

    if (formValid) {
      const button = document.querySelector('.submit-application')
      button.classList.add('loading')
      const data = inputs.map(input => ({name: input.name, content: input.value}))
      data.push({name: 'role', content: job.header})

      const fileInput = document.getElementById('cv')
      const file = fileInput.files[0]
      const reader = new FileReader()
      const self = this

      reader.onload = function (e) {
        const fileData = e.target.result
        self.sendEmail(data, file, fileData)
      }
      reader.readAsDataURL(file)
    }
    e.preventDefault()
  }

  sendEmail (data, fileInfo, fileData) {
    const templateName = 'bronze-website-new-application'
    const templateContent = []
    // const name = data.find(item => item.name === 'firstName').content + ' ' + data.find(item => item.name === 'lastName').content
    const email = data.find(item => item.name === 'email').content
    const attachment = {
      'type': fileInfo.type,
      'name': fileInfo.name,
      'content': fileData.substr(fileData.indexOf(',') + 1)
    }

    const message = {
      'to': [{
        'email': 'iwant2work@bronzelabs.co.uk',
        'name': 'Bronze Careers',
        'type': 'to'
      }],
      'headers': {
        'Reply-To': email
      },
      'important': false,
      'track_opens': null,
      'track_clicks': null,
      'auto_text': null,
      'auto_html': null,
      'inline_css': null,
      'url_strip_qs': null,
      'preserve_recipients': null,
      'view_content_link': null,
      'tracking_domain': null,
      'signing_domain': null,
      'return_path_domain': null,
      'merge': true,
      'merge_language': 'mailchimp',
      'global_merge_vars': data,
      'attachments': [attachment]
    }

    const async = false
    const ipPool = null
    const sendAt = null

    const self = this
    mandrillClient.messages.sendTemplate({template_name: templateName, template_content: templateContent, message: message, async: async, ip_pool: ipPool, send_at: sendAt}, function (result) {
      // success
      self.sendConfirmationEmail(data)
    },
    function (error) {
      // error - do something with error?
      // console.log('error occured: ' + error.name + ' ' + error.message)
      const button = document.querySelector('.submit-application')
      button.classList.add('error')
      button.innerHTML = '<i class="ac ac-close"></i> Error Submitting'
      button.classList.remove('loading')
    })
  }

  sendConfirmationEmail (data) {
    const templateName = 'bronze-website-application-confirmation'
    const templateContent = [data]

    const name = data.find(item => item.name === 'firstName').content + ' ' + data.find(item => item.name === 'lastName').content
    const email = data.find(item => item.name === 'email').content

    const message = {
      'to': [{
        'email': email,
        'name': name,
        'type': 'to'
      }],
      'important': false,
      'track_opens': null,
      'track_clicks': null,
      'auto_text': null,
      'auto_html': null,
      'inline_css': null,
      'url_strip_qs': null,
      'preserve_recipients': null,
      'view_content_link': null,
      'tracking_domain': null,
      'signing_domain': null,
      'return_path_domain': null,
      'merge': true,
      'merge_language': 'mailchimp',
      'global_merge_vars': data
    }

    const async = false
    const ipPool = null
    const sendAt = null

    const button = document.querySelector('.submit-application')
    mandrillClient.messages.sendTemplate({template_name: templateName, template_content: templateContent, message: message, async: async, ip_pool: ipPool, send_at: sendAt}, function (result) {
      button.innerHTML = '<i class="ac ac-check"></i>Application Sent'
      button.classList.remove('loading')
    },
    function (error) {
      // error - do something with error?
      // console.log('error occured: ' + error.name + ' ' + error.message)
      button.classList.add('error')
      button.innerHTML = '<i class="ac ac-close"></i> Error Submitting'
      button.classList.remove('loading')
    })
  }

  render () {
    if (!this.props.jobs || this.props.jobs.length === 0) {
      return (
        <div className='loading-modal'>
          <div className='spinner'>
            <div className='bounce1' />
            <div className='bounce2' />
            <div className='bounce3' />
          </div>
        </div>
      )
    }

    const job = this.props.jobs.filter((job) => job.id === this.props.match.params.job)[0] || null
    if(!job) {
      this.props.setModal(false)
      return <NotFound />
    }

    return (
      <div className='modal'>
        <section>
          <Row classes={['marginBottom']}>
            <Content classes={['contentFull']}>
              <h1>{job.header}</h1>
              <p className="salary">{job.salary}</p>
              <h3>{job.text}</h3>
            </Content>
          </Row>

          {
            job.requirements !== undefined && job.requirements.length > 0 &&
            <span>
              <Row>
                <Content classes={['contentFull']}>
                  <h2>Requirements</h2>
                </Content>
              </Row>
              <Row>
                <Content classes={['contentFull']}>
                  <ol>
                    {
                      job.requirements.map((item, index) => <li key={index}>{item}</li>)
                    }
                  </ol>
                </Content>
              </Row>
            </span>
          }
          {
            job.skills !== undefined && job.skills.length > 0 &&
            <span>
              <Row>
                <Content classes={['contentFull']}>
                  <h2>Skillset</h2>
                </Content>
              </Row>
              <Row>
                <Content classes={['contentFull']}>
                  <ol>
                    {
                      job.skills.map((item, index) => <li key={index}>{item}</li>)
                    }
                  </ol>
                </Content>
              </Row>
            </span>
          }
          <Row>
            <Content classes={['contentFull']}>
              <h2>Interested?</h2>
              <p>To apply for this job opportunity, please email us with a brief introduction about yourself, your cv and links to relevant work, such as online portfolio or github profile.</p>
              <Button icon='ac-mail' classes={['button-primary']} text='Send us an email' href='mailto:iwant2work@bronzelabs.co.uk?subject=I want to work at Bronze Labs&body=Hello, I would love a career at Bronze Labs with you guys. Please find my CV attached for your consideration and a bit about me below!' />
            </Content>
          </Row>
          {/*<form onSubmit={(e) => this.handleForm(e, job)}>
            <Row>
              <Content classes={['contentFull']}>
                <h3>Personal details</h3>
              </Content>
            </Row>
            <Row>
              <Content>
                <label>First name</label>
                <input type='text' name='firstName' />
              </Content>
              <Content>
                <label>Last name</label>
                <input type='text' name='lastName' />
              </Content>
            </Row>
            <Row>
              <Content>
                <label>Contact number</label>
                <input type='text' name='contactNumber' />
              </Content>
              <Content>
                <label>Email address</label>
                <input type='text' name='email' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>Postal address</label>
                <input type='text' name='address' />
              </Content>
            </Row>
            
            <Row>
              <Content classes={['contentFull']}>
                <h3>Some questions</h3>
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>If you could work on anything in the world right now, what would it be and why?</label>
                <input type='text' name='questionOne' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>Tell us about your greatest achievement to date</label>
                <input type='text' name='questionTwo' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>Describe the work environment in which you will most effectively be able to contribute</label>
                <input type='text' name='questionThree' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>Tell us about a time when you had to overcome a major obstacle that stood in the way of you accomplishing a goal or commitment.​ How did you approach the situation?​</label>
                <input type='text' name='questionFour' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>What prompted you to apply for this job? What interested you the most about this position?​ </label>
                <input type='text' name='questionFive' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>What are the three most important attributes or skills that you believe you would bring to our company if we hired you?</label>
                <input type='text' name='questionSix' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>How do you believe that your current skills will contribute to the accomplishment of our company's mission?</label>
                <input type='text' name='questionSeven' />
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <h3>Your CV</h3>
              </Content>
            </Row>
            <Row>
              <Content classes={['contentFull']}>
                <label>Please attach your CV (Word or PDF)</label>
                <input type='file' id='cv' name='cv' accept='.doc, .docx, .pdf' />
              </Content>
            </Row>
            <Row>
              <Content>
                <button type='submit' className='button-primary submit-application'><i className='ac ac-mail' />Send application</button>
              </Content>
            </Row>
          </form>  */}
        </section>
      </div>
    )
  }
}

JobSpecification.propTypes = {
  setModal: PropTypes.func,
  jobs: PropTypes.array,
  match: PropTypes.object
}

export default JobSpecification



// WEBPACK FOOTER //
// ./src/containers/JobSpecification.js